class UnableToAccessUsingExternalDomainException extends Error {
  constructor(message) {
    super(message);
    this.name = 'UnableToAccessUsingExternalDomainException';
  }
}

export default UnableToAccessUsingExternalDomainException;
